module.exports = __webpack_public_path__ + "img/logo_navbar.ece1047a.png";